var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 57.177,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 56.807
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.787,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 56.807
  }), /*#__PURE__*/React.createElement("rect", {
    y: 284.397,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 56.807
  })), /*#__PURE__*/React.createElement("rect", {
    y: 341.207,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 56.807
  }), /*#__PURE__*/React.createElement("rect", {
    y: 398.017,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 56.807
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 454.827,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 56.807
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "512,57.173 512,0.366 0,0.366 0,113.98 0,170.788 0,284.402 512,284.402 512,227.595    269.087,227.595 269.087,170.788 512,170.788 512,113.98 269.087,113.98 269.087,57.173  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "269.087,113.98 162.946,113.98 162.946,0.366 106.14,0.366 106.14,113.98 0,113.98   0,170.788 106.14,170.788 106.14,284.402 162.946,284.402 162.946,170.788 269.087,170.788 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/gr.71eb9542a6aea6de2f55dfa42e623c69.svg";
export { ForwardRef as ReactComponent };